import { render, staticRenderFns } from "./FornitoriEdit.vue?vue&type=template&id=76d08654&"
import script from "./FornitoriEdit.vue?vue&type=script&lang=ts&"
export * from "./FornitoriEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports